import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
// Components
import CustomButton from 'components/common/CustomButton';
// API
import OrderDetailsService from 'services/OrderDetailsService';

/**
 * Pause needs an active reason from the shared pause-reasons list, same as the
 * order-level pause.
 */
const TaskPauseModal = ({ isOpen, setIsOpen, taskLabel, onConfirm, isDisabled }) => {
  const [reasons, setReasons] = useState([]);
  const [reasonId, setReasonId] = useState('');

  useEffect(() => {
    const fetchReasons = async () => {
      try {
        const res = await OrderDetailsService.getPauseReasons();
        setReasons(res?.data ?? []);
      } catch (err) {
        setReasons([]);
      }
    };
    fetchReasons();
  }, []);

  return (
    <Modal isOpen={isOpen} toggle={() => setIsOpen(false)} className="pause-order-modal" centered>
      <ModalHeader
        close={
          <span className="pause-modal-close" onClick={() => setIsOpen(false)}>
            &times;
          </span>
        }
      >
        Pause task
      </ModalHeader>
      <ModalBody>
        <p className="pause-modal-description">
          Select a reason for pausing {taskLabel ? <b>{taskLabel}</b> : 'this task'}. You can start
          another task while this one is paused.
        </p>
        <div className="pause-reason-select">
          <label>Pause Reason</label>
          <select value={reasonId} onChange={(e) => setReasonId(e.target.value)}>
            <option value="" disabled>
              Select a reason
            </option>
            {reasons.map((reason) => (
              <option key={reason.id} value={reason.id}>
                {reason.reason}
              </option>
            ))}
          </select>
        </div>
      </ModalBody>
      <ModalFooter className="pause-modal-footer">
        <CustomButton
          id="task-pause-cancel"
          name="Cancel"
          handleClick={() => setIsOpen(false)}
          type="cancel"
          cssClasses="pause-cancel-btn"
        />
        <CustomButton
          id="task-pause-confirm"
          name="Pause task"
          handleClick={() => onConfirm(parseInt(reasonId, 10))}
          type="proceed"
          cssClasses="pause-confirm-btn"
          disabled={!reasonId || isDisabled}
        />
      </ModalFooter>
    </Modal>
  );
};

export default TaskPauseModal;
